export const clientAddUserPermissionSchema = {
    id_user: '{type:"readOnly", rules:"required", storeNamespace: "clientsUser", objectNamespace: "O_user", itemText: "name"}',
    id_groups: '{type:"selectData", rules:"required", storeNamespace: "clients", objectNamespace: "A_group", itemText: "name", multiple:"true"}',
    date_valid_from: '{type: "datePicker"}',
    date_valid_to: '{type: "datePicker"}',
    grant: '{type: "switch", rules:"required", label:"Grant access to assign permissions"}'
}

